// Helper: scroll to a section by id and optionally set Contact form flow.
//
// `flow`: "price" | "book" — when set, dispatches a window event that the
// Contact component listens for and switches its tab accordingly.

export const scrollToSection = (id, opts = {}) => {
  const { flow } = opts;
  if (id === "contact" && typeof document !== "undefined") document.body.dataset.bookingActive = "1";
  const el = typeof document !== "undefined" ? document.getElementById(id) : null;
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  } else if (typeof window !== "undefined") {
    // Defer in case the page is still mounting (route change)
    setTimeout(() => {
      const e2 = document.getElementById(id);
      if (e2) e2.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 80);
  }
  if (flow && typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("puregloss:set-flow", { detail: { flow } }));
  }
};

const HOME_RE = /^\/(de|uk|en|pl|ru)\/?$/;

export const navigateAndScroll = (navigate, id, opts = {}) => {
  if (typeof window !== "undefined" && !HOME_RE.test(window.location.pathname)) {
    const m = window.location.pathname.match(/^\/(de|uk|en|pl|ru)(\/|$)/);
    navigate(m ? `/${m[1]}/` : "/");
    setTimeout(() => scrollToSection(id, opts), 120);
  } else {
    scrollToSection(id, opts);
  }
};
